export const websiteArray = [
  {
    src:"https://www.w3schools.com/w3css/img_temp_portfolio3.jpg" , alt:"people portfolio 2" , route:"/people_portfolio_2"
  },
  {
    src:"https://www.w3schools.com/w3css/img_temp_portfolio2.jpg" , alt:"people portfolio" , route:"/people_portfolio"
  },
  {
    src:"https://www.w3schools.com/w3css/img_temp_photo.jpg" , alt:"photo" , route:"/photo"
  },
  {
    src:"https://www.w3schools.com/w3css/img_temp_modal_restaurant.jpg" , alt:"modal restaurant" , route:"/modal_restaurant"
  },
  {
    src:"https://www.w3schools.com/w3css/img_temp_wedding.jpg" , alt:"wedding invitation" , route:"/wedding_invitation"
  },
  {
    src:"https://www.w3schools.com/w3css/img_temp_travel2.jpg" , alt:"travel" , route:"/travel"
  },
  {
    src:"https://www.w3schools.com/w3css/img_temp_cv.jpg" , alt:"cv" , route:"/cv"
  },
  {
    src:"https://www.w3schools.com/w3css/img_temp_dark_icon.jpg" , alt:"dark portfolio" , route:"/dark_portfolio"
  },

    {
      src:"https://www.w3schools.com/w3css/img_temp_clothing_store.jpg" , alt:"clothing store" , route:"/clothing_store"
    },

    {
      src:"https://www.w3schools.com/w3css/img_temp_cafe.jpg" , alt:"cafe" , route:"/cafe"
    },
    {
        src:"https://www.w3schools.com/w3css/img_temp_blog.jpg" , alt:"blog" , route:"/blog" 
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_band.jpg" , alt:"band" , route:"/band" 
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_art.jpg" , alt:"art" , route:"/art" 
      },      
      {
        src:"https://www.w3schools.com/w3css/img_temp_photo2.jpg" , alt:"black and white photo" , route:"/black_and_white_photo" 
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_architect.jpg" , alt:"architect" , route:"/architect" 
      },
    {
       src:"https://www.w3schools.com/w3css/img_temp_gourmet_catering.jpg" , alt:"gourmet catering" , route:"/gourmet_catering"
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_comingsoon.jpg" , alt:"coming soon" , route:"/coming_soon" 
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_parallax.jpg" , alt:"parallax" , route:"/parallax" 
      },
    {
       src:"https://www.w3schools.com/w3css/img_temp_photo3.jpg" , alt:"photo portfolio" , route:"/photo_portfolio"
      },
     {
       src:"https://www.w3schools.com/w3css/img_temp_food_blog.jpg" , alt:"food blog" , route:"/food_blog"
      },
     {
       src:"https://www.w3schools.com/w3css/img_temp_fashion_blog.jpg" , alt:"fashion blog" , route:"/fashion_blog"
      },
     {
       src:"https://www.w3schools.com/w3css/img_temp_travel.jpg" , alt:"travel agency" , route:"/travel_agency"
      },
     {
       src:"https://www.w3schools.com/w3css/img_temp_pizza.jpg" , alt:"pizza restaurant" , route:"/pizza_restaurant"
      },
     {
       src:"https://www.w3schools.com/w3css/img_temp_analytics.jpg" , alt:"analytics" , route:"/analytics"
      },
     {
       src:"https://www.w3schools.com/w3css/img_temp_fifty.jpg" , alt:"screen 50" , route:"/screen_50"
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_startpage.jpg" , alt:"start page" , route:"/start_page"
       },
      {
        src:"https://www.w3schools.com/w3css/img_temp_app_launch.jpg" , alt:"app launch" , route:"/app_launch"
       },
      {
        src:"https://www.w3schools.com/w3css/img_temp_apartment_rental.jpg" , alt:"apartment rental" , route:"/apartment_rental"
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_hotel.jpg" , alt:"hotel" , route:"/hotel"
      },
      {
        src:"https://www.w3schools.com/Css/img_temp_design.jpg" , alt:"house design" , route:"/house_design"
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_interior_design.jpg" , alt:"interior design" , route:"/interior_design"
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_mail.jpg" , alt:"mail" , route:"/mail"
      },
      {
        src:"https://www.w3schools.com/Css/img_temp_marketing.jpg" , alt:"marketing" , route:"/marketing"
      },
      {
        src:"https://www.w3schools.com/Css/img_temp_website.jpg" , alt:"marketing website" , route:"/marketing_website"
      },
      {
        src:"https://www.w3schools.com/w3css/img_temp_portfolio.jpg" , alt:"nature portfolio" , route:"/nature_portfolio"
      },
      {
        src:"https://www.w3schools.com/Css/img_temp_social.jpg" , alt:"social media" , route:"/social_media"
      },
       {
        src:"https://www.w3schools.com/w3css/img_temp_startup.jpg" , alt:"start up" , route:"/startup"
      },
      {
        src:"https://www.w3schools.com/Css/img_temp_webpage.jpg" , alt:"web page" , route:"/web_page"
      },
]



